<div class="appraisals-templates-container">

  <!-- Header -->
  <div class="list-header">
    <div class="header-title">
      <h3>
        <i class="fa fa-file-text-o" aria-hidden="true" style="color: #0f766e; font-size: 18px; line-height: 1; margin-right: 8px;"></i>
        <span translate>APPRAISAL_TEMPLATES</span>
      </h3>
      <span class="record-count"
        >{{ totalItems }} {{ "FORMS" | translate }}</span
      >
    </div>
    <div class="header-actions">
      <button
        *ngIf="canCreateTemplate"
        class="btn btn-success"
        (click)="createTemplate()"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span translate>NEW_TEMPLATE</span>
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-section">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label translate>TEMPLATE_NAME</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="nameFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label translate>STATUS</label>
          <select
            class="form-control"
            [(ngModel)]="statusFilter"
            (ngModelChange)="onFilterChange()"
          >
            <option *ngFor="let status of statusOptions" [ngValue]="status.value">
              {{ status.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label translate>DEPARTMENT</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="departmentFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group filter-actions">
          <label>&nbsp;</label>
          <button
            class="btn btn-outline-secondary clear-filters-btn"
            (click)="clearFilters()"
          >
            <i class="fa fa-filter" aria-hidden="true"></i>
            <span translate>CLEAR_FILTERS</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-view">
    <p-table
      [value]="templateFamilies"
      dataKey="FamilyKey"
      [rows]="pageSize"
      [totalRecords]="totalItems"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [loading]="isLoading"
      [(selection)]="selectedTemplates"
      [sortField]="sortField"
      [sortOrder]="sortOrder === 'ASC' ? 1 : -1"
      (onPage)="onPageChange($event)"
      (onSort)="onSort($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}: {{
        totalItems
      }}"
      styleClass="p-datatable-striped"
    >
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Name" class="template-name-column">
            {{ "TEMPLATE_NAME" | translate }}
            <p-sortIcon field="Name"></p-sortIcon>
          </th>
          <th class="status-column">
            {{ "STATUS" | translate }}
          </th>
          <th class="version-column">
            {{ "VERSION" | translate }}
          </th>
          <th class="departments-column">
            {{ "ASSIGNED_DEPARTMENTS" | translate }}
          </th>
          <th pSortableColumn="CreatedOn" class="created-column">
            {{ "CREATED_ON" | translate }}
            <p-sortIcon field="CreatedOn"></p-sortIcon>
          </th>
          <th class="actions-column">
            {{ "ACTIONS" | translate }}
          </th>
        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-family>
        <tr>
          <td class="template-name-column">
            <div class="template-info">
              <strong [title]="family.DisplayName">{{ family.DisplayName }}</strong>
              <small
                *ngIf="family.CurrentTemplate.Description"
                [title]="family.CurrentTemplate.Description"
              >{{
                family.CurrentTemplate.Description
              }}</small>
              <small class="template-family-meta">
                <ng-container *ngIf="hasVersionHistory(family); else currentVersionLabel">
                  +{{ getOlderVersionCount(family) }}
                  {{
                    (getOlderVersionCount(family) === 1
                      ? 'APPRAISAL_OLDER_VERSION'
                      : 'APPRAISAL_OLDER_VERSIONS'
                    ) | translate
                  }}
                </ng-container>
                <ng-template #currentVersionLabel>
                  {{ 'APPRAISAL_CURRENT_VERSION' | translate }}
                </ng-template>
              </small>
              <span
                *ngIf="family.CurrentTemplate.HasMeetings"
                class="template-usage-chip"
                [attr.title]="'TEMPLATE_DELETE_BLOCKED_HAS_MEETINGS' | translate"
              >
                <i class="fa fa-lock" aria-hidden="true"></i>
                {{ 'TEMPLATE_USED_IN_MEETINGS' | translate }}
              </span>
            </div>
          </td>
          <td class="status-column">
            <span
              class="status-badge"
              [class.active]="family.CurrentTemplate.IsActive"
              [class.inactive]="!family.CurrentTemplate.IsActive"
              [attr.title]="(family.CurrentTemplate.IsActive ? 'ACTIVE' : 'INACTIVE') | translate"
            >
              {{ (family.CurrentTemplate.IsActive ? "ACTIVE" : "INACTIVE") | translate }}
            </span>
          </td>
          <td class="version-column text-center">
            <div class="version-cell">
              <span class="version-badge">v{{ family.CurrentTemplate.Version }}</span>
              <small
                *ngIf="hasVersionHistory(family)"
                [attr.title]="
                  getOlderVersionCount(family) + ' ' +
                  ((getOlderVersionCount(family) === 1
                    ? 'APPRAISAL_OLDER_VERSION'
                    : 'APPRAISAL_OLDER_VERSIONS') | translate)
                "
              >
                +{{ getOlderVersionCount(family) }}
              </small>
            </div>
          </td>
          <td class="departments-column">
            <div class="departments-list">
              <span
                *ngIf="family.CurrentTemplate.AssignedDepartments.length === 0"
                class="text-muted"
              >
                {{ "NO_ASSIGNMENTS" | translate }}
              </span>
              <div
                *ngIf="family.CurrentTemplate.AssignedDepartments.length > 0"
                class="department-tags"
              >
                <span
                  *ngFor="let dept of family.CurrentTemplate.AssignedDepartments.slice(0, 1)"
                  class="department-tag"
                  [title]="dept.Name"
                >
                  {{ dept.Name }}
                </span>
                <span
                  *ngIf="family.CurrentTemplate.AssignedDepartments.length > 1"
                  class="more-tag"
                >
                  +{{ family.CurrentTemplate.AssignedDepartments.length - 1 }}
                </span>
              </div>
            </div>
          </td>
          <td class="created-column">
            <div class="created-info">
              <div [title]="family.CurrentTemplate.CreatedBy.Name">
                {{ family.CurrentTemplate.CreatedBy.Name }}
              </div>
              <small>{{
                family.CurrentTemplate.CreatedBy.CreatedOn | utcDate : "dd-MM-yyyy"
              }}</small>
            </div>
          </td>
          <td class="actions-column">
            <div class="action-menu">
              <button
                class="btn btn-sm btn-outline-secondary action-menu-trigger"
                (click)="openActionMenu($event, family.CurrentTemplate)"
                [disabled]="!canInteractWithTemplate(family.CurrentTemplate)"
                [title]="'ACTIONS' | translate"
                [attr.aria-label]="'ACTIONS' | translate"
              >
                <i
                  class="fa"
                  [ngClass]="
                    isTemplateActionPending(family.CurrentTemplate.Id)
                      ? 'fa-spinner fa-spin'
                      : 'fa-ellipsis-v'
                  "
                  aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-family>
        <tr class="version-history-row">
          <td colspan="6">
            <div class="version-history-panel">
              <div class="version-history-header">
                <strong>{{ 'VERSION' | translate }} {{ 'HISTORY' | translate }}</strong>
                <span class="version-history-count">
                  {{ family.Versions.length }}
                  {{
                    (family.Versions.length === 1 ? 'VERSION' : 'APPRAISAL_VERSIONS')
                      | translate
                  }}
                </span>
              </div>

              <div class="version-history-list">
                <div
                  *ngFor="let version of family.Versions"
                  class="version-history-item"
                  [class.current]="version.Id === family.CurrentTemplate.Id"
                >
                  <div class="version-history-main">
                    <div class="version-history-badges">
                      <span class="version-badge">v{{ version.Version }}</span>
                      <span class="history-state-chip">
                        {{ getVersionStateLabel(family, version) }}
                      </span>
                      <span
                        *ngIf="version.HasMeetings"
                        class="template-usage-chip"
                        [attr.title]="'TEMPLATE_DELETE_BLOCKED_HAS_MEETINGS' | translate"
                      >
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        {{ 'TEMPLATE_USED_IN_MEETINGS' | translate }}
                      </span>
                      <span
                        class="status-badge"
                        [class.active]="version.IsActive"
                        [class.inactive]="!version.IsActive"
                      >
                        {{ (version.IsActive ? 'ACTIVE' : 'INACTIVE') | translate }}
                      </span>
                    </div>

                    <div class="version-history-title">
                      {{ version.Name }}
                    </div>
                    <div
                      *ngIf="version.Description"
                      class="version-history-description"
                    >
                      {{ version.Description }}
                    </div>

                    <div class="version-history-meta">
                      <span>{{ version.CreatedBy.Name }}</span>
                      <span>{{ version.CreatedBy.CreatedOn | utcDate : 'dd-MM-yyyy' }}</span>
                    </div>
                  </div>

                  <div class="version-history-actions">
                    <div class="action-menu">
                      <button
                        class="btn btn-sm btn-outline-secondary action-menu-trigger"
                        (click)="openActionMenu($event, version)"
                        [disabled]="!canInteractWithTemplate(version)"
                        [title]="'ACTIONS' | translate"
                        [attr.aria-label]="'ACTIONS' | translate"
                      >
                        <i
                          class="fa"
                          [ngClass]="
                            isTemplateActionPending(version.Id)
                              ? 'fa-spinner fa-spin'
                              : 'fa-ellipsis-v'
                          "
                          aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Empty message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">
            <div class="empty-state">
              <i class="fa fa-file-text-o empty-state-icon" aria-hidden="true"></i>
              <p class="empty-state-title" translate>
                APPRAISAL_EMPTY_TEMPLATES_TITLE
              </p>
              <p class="empty-state-body" translate>
                APPRAISAL_EMPTY_TEMPLATES_BODY
              </p>
              <button
                *ngIf="canCreateTemplate"
                class="btn btn-success"
                (click)="createTemplate()"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
                <span translate>CREATE_FIRST_TEMPLATE</span>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div
    *ngIf="currentActionTemplate"
    class="template-actions-dropdown"
    [style.top.px]="actionMenuPosition.top"
    [style.left.px]="actionMenuPosition.left"
    (click)="$event.stopPropagation()"
  >
    <div class="action-menu-items">
      <button
        class="action-menu-item"
        type="button"
        (click)="onTemplateAction('view', currentActionTemplate)"
      >
        <i class="fa fa-eye" aria-hidden="true"></i>
        <span translate>VIEW</span>
      </button>

      <button
        *ngIf="canEditTemplate"
        class="action-menu-item"
        type="button"
        (click)="onTemplateAction('edit', currentActionTemplate)"
      >
        <i class="fa fa-pencil" aria-hidden="true"></i>
        <span translate>EDIT</span>
      </button>

      <button
        class="action-menu-item"
        type="button"
        (click)="onTemplateAction('toggle', currentActionTemplate)"
      >
        <i
          class="fa"
          [ngClass]="currentActionTemplate.IsActive ? 'fa-pause' : 'fa-play'"
          aria-hidden="true"
        ></i>
        <span>{{
          (currentActionTemplate.IsActive ? "DEACTIVATE" : "ACTIVATE") | translate
        }}</span>
      </button>

      <button
        *ngIf="canDeleteTemplate && currentActionTemplate.HasMeetings"
        class="action-menu-item disabled-info"
        type="button"
        disabled
        [title]="'TEMPLATE_DELETE_BLOCKED_HAS_MEETINGS' | translate"
      >
        <i class="fa fa-lock" aria-hidden="true"></i>
        <span translate>TEMPLATE_USED_IN_MEETINGS</span>
      </button>

      <button
        *ngIf="canDeleteTemplateRow(currentActionTemplate)"
        class="action-menu-item danger"
        type="button"
        (click)="onTemplateAction('delete', currentActionTemplate)"
      >
        <i class="fa fa-trash" aria-hidden="true"></i>
        <span translate>DELETE</span>
      </button>
    </div>
  </div>
</div>

<p-dialog
  header="{{ 'CHANGE_STATUS' | translate }}"
  [(visible)]="openChangeStatusDialog"
  [style]="{ width: '450px' }"
  [resizable]="false"
  [draggable]="false"
>
  <p>
    <span translate>THIS_ACTION_WILL_CHANGE_STATUS_OF</span>
    <span> {{ selectedTemplates.length }} </span>
    <span translate>FORMS</span>
    <span>.</span>
  </p>
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="isUpdatingSelectedTemplateStatuses"
      (click)="changeStatusOfSelectedTemplates(true)"
    >
      <i
        *ngIf="isUpdatingSelectedTemplateStatuses && selectedTemplateStatusTarget === true"
        class="fa fa-spinner fa-spin"
        aria-hidden="true"></i>
      <span translate>ACTIVATE</span>
    </button>
    <button
      type="button"
      class="btn btn-warning"
      [disabled]="isUpdatingSelectedTemplateStatuses"
      (click)="changeStatusOfSelectedTemplates(false)"
    >
      <i
        *ngIf="isUpdatingSelectedTemplateStatuses && selectedTemplateStatusTarget === false"
        class="fa fa-spinner fa-spin"
        aria-hidden="true"></i>
      <span translate>DEACTIVATE</span>
    </button>
    <button
      type="button"
      class="btn btn-outline-primary"
      [disabled]="isUpdatingSelectedTemplateStatuses"
      (click)="openChangeStatusDialog = false"
    >
      <span translate>CANCEL</span>
    </button>
  </div>
</p-dialog>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
